module.exports = __webpack_public_path__ + "static/media/ebike.aa94a18a.jpg";